import { styled } from 'styled-components';

export const StyledOl = styled('ol')`
  list-style-type: decimal;
  padding-left: 20px;
`;

export const StyledLi = styled('li')`
  ${({ theme }) => theme.typography.xSmall}
  color: ${({ theme }) => theme.color.darkerGray};
  margin-bottom: ${({ theme }) => theme.x0_5}px;
  &:last-child {
    margin-bottom: 0;
  }
`;
